/* motion: pick feel. Press feedback is CSS; this adds landing/releasing hooks on change only. */
import './pick.css';

const WINDOW_MS = 1500;
const LAND_MS = 450;

/** The user-tap window: only a [data-pick] tap opens it; any other tap closes it. */
export function createPickWindow(now: () => number = () => performance.now()) {
  let game = '';
  let at = -Infinity;
  return {
    open(g: string) {
      game = g;
      at = now();
    },
    close() {
      game = '';
      at = -Infinity;
    },
    allows(g: string | undefined) {
      return now() - at <= WINDOW_MS && g === game;
    },
  };
}

export function init(root: HTMLElement): void {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const win = createPickWindow();

  root.addEventListener(
    'click',
    (e) => {
    const btn = (e.target as Element | null)?.closest<HTMLButtonElement>('[data-pick]');
    if (!btn || btn.disabled) {
      win.close(); // player chip, week, theme...: never a pick, so no animation
      return;
    }
    win.open(btn.dataset.game ?? '');
    if (!btn.classList.contains('team-btn--picked') && !reduced.matches) navigator.vibrate?.(8);
    },
    true, // capture: stamp before ui.ts's bubble handler repaints
  );

  const flag = (el: HTMLElement, cls: string) => {
    el.classList.remove(cls);
    void el.offsetWidth; // restart the animation
    el.classList.add(cls);
    window.setTimeout(() => el.classList.remove(cls), LAND_MS);
  };

  new MutationObserver((records) => {
    for (const r of records) {
      const el = r.target as HTMLElement;
      if (!el.classList?.contains('team-btn') || !win.allows(el.dataset.game)) continue;
      const was = (r.oldValue ?? '').split(' ').includes('team-btn--picked');
      const now = el.classList.contains('team-btn--picked');
      if (now && !was) flag(el, 'is-landing');
      else if (!now && was) flag(el, 'is-releasing');
    }
  }).observe(root, { subtree: true, attributes: true, attributeFilter: ['class'], attributeOldValue: true });
}
